module.exports = __webpack_public_path__ + "img/minting-parsomen-empty.d10f99c0.webp";